export default "__VITE_ASSET__C0TmXb$N__"